import { render } from "./Analysis.vue?vue&type=template&id=a8d8580e&scoped=true"
import script from "./Analysis.vue?vue&type=script&lang=js"
export * from "./Analysis.vue?vue&type=script&lang=js"

import "./Analysis.vue?vue&type=style&index=0&id=a8d8580e&lang=css"
import "./Analysis.vue?vue&type=style&index=1&id=a8d8580e&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8d8580e"]])

export default __exports__